import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../config/constants';
import { authService } from '../services/api.service';

const Login = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.login(formData.username, formData.password);
      localStorage.setItem('abell_token', response.access_token);
      localStorage.setItem('abell_user', JSON.stringify(response.user));
      onLoginSuccess(response.user);
    } catch (err) {
      setError(err.response?.data?.detail || 'Giriş başarısız. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="login-page"
      style={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem'
      }}
    >
      <div
        style={{
          background: COLORS.white,
          borderRadius: '16px',
          padding: '3rem',
          maxWidth: '450px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
      >
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img 
            src="/abell-logo.svg" 
            alt="Abell Logo" 
            style={{
              width: '140px',
              height: 'auto',
              margin: '0 auto 1rem',
              display: 'block'
            }}
          />
          <h1 style={{ fontSize: '2rem', fontWeight: '700', color: COLORS.text, marginBottom: '0.5rem', letterSpacing: '1px' }}>
            ABELL
          </h1>
          <p style={{ color: COLORS.textLight, fontSize: '0.95rem' }}>
            Takip Sistemi
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                color: COLORS.text,
                fontWeight: '500',
                fontSize: '0.9rem'
              }}
            >
              Kullanıcı Adı
            </label>
            <input
              data-testid="username-input"
              type="text"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                border: `2px solid ${COLORS.background}`,
                borderRadius: '8px',
                fontSize: '1rem',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = COLORS.primary}
              onBlur={(e) => e.target.style.borderColor = COLORS.background}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                color: COLORS.text,
                fontWeight: '500',
                fontSize: '0.9rem'
              }}
            >
              Şifre
            </label>
            <input
              data-testid="password-input"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                border: `2px solid ${COLORS.background}`,
                borderRadius: '8px',
                fontSize: '1rem',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = COLORS.primary}
              onBlur={(e) => e.target.style.borderColor = COLORS.background}
            />
          </div>

          {error && (
            <div
              data-testid="error-message"
              style={{
                padding: '0.75rem',
                background: '#fee2e2',
                color: COLORS.error,
                borderRadius: '8px',
                marginBottom: '1rem',
                fontSize: '0.9rem'
              }}
            >
              {error}
            </div>
          )}

          <button
            data-testid="login-button"
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.875rem',
              background: loading ? COLORS.textLight : COLORS.primary,
              color: COLORS.white,
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '1rem'
            }}
            onMouseEnter={(e) => !loading && (e.target.style.background = '#8a0303')}
            onMouseLeave={(e) => !loading && (e.target.style.background = COLORS.primary)}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>

          {/* Forgot Password Link */}
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              onClick={() => navigate('/forgot-password')}
              style={{
                background: 'none',
                border: 'none',
                color: COLORS.primary,
                fontSize: '0.9rem',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: '0.5rem'
              }}
            >
              🔑 Şifremi Unuttum?
            </button>
          </div>
        </form>

        {/* Info */}
        <div style={{ marginTop: '2rem', textAlign: 'center', color: COLORS.textLight, fontSize: '0.85rem' }}>
          <p>Varsayılan: admin / admin123</p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}>Gelecek Bizimle Daha Parlak</p>
        </div>
      </div>
    </div>
  );
};

export default Login;